module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-template', [_c('module-wrapper', {
    attrs: {
      "businessAreaId": _vm.businessAreaId,
      "systemId": _vm.systemId,
      "systemVersion": _vm.systemVersion,
      "formId": _vm.formId
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "SGSNow - Report Viewer",
      "visible": _vm.exportPdfViewer,
      "size": "full"
    },
    on: {
      "update:visible": function($event) {
        _vm.exportPdfViewer = $event
      }
    }
  }, [_c('object', {
    attrs: {
      "data": _vm.exportPdfViewerData,
      "type": "application/pdf",
      "width": "100%",
      "height": _vm.exportPdfViewerHeight
    }
  })]), _vm._v(" "), (_vm.showDialogForm.showDialogWithForm) ? _c('el-dialog', {
    attrs: {
      "visible": _vm.showDialogForm.showDialogWithForm,
      "size": "large",
      "id": "modal",
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.showDialogForm, "showDialogWithForm", $event)
      }
    }
  }, [_c('module-template', [_c('module-wrapper', {
    attrs: {
      "businessAreaId": _vm.businessAreaId,
      "systemId": _vm.systemId,
      "systemVersion": _vm.systemVersion,
      "formId": _vm.showDialogForm.formIdModal,
      "parentId": _vm.showDialogForm.parentIdModal
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.autoComplete) ? _c('auto-complete', {
    attrs: {
      "payload": _vm.autoComplete.payload,
      "callback": _vm.autoComplete.callback
    },
    on: {
      "autoCompleteClose": _vm.autoCompleteClose
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-190ad8bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/module/components/Module.vue
// module id = 894
// module chunks = 2